const content = [
  {
    title: 'How is the gift card delivered?',
    text:
      'The gift card is delivered by Royal Mail 1st Class. You choose where you want it delivered - whether it be to yourself for tweaking or to your loved one.',
  },
  {
    title: 'How long does the giftcard last for?',
    text:
      'Gift cards are valid for one year from delivery. Once redeemed, your loved one has one year to take their gifted trips.',
  },
  {
    title: 'How many trips can I buy?',
    text: 'You can buy up to three trips on the Go Solo or Go Together plans.',
  },
  {
    title: 'Can I use the gift card myself?',
    text:
      'Of course! Codes are single use and unique, but can be redeemed against any account.',
  },
  {
    title: 'Are gift cards refundable?',
    text:
      "If your gift card hasn't been redeemed it's 100% refundable, however we can only refund to the card we billed originally. Once redeemed, gift cards can't be refunded.",
  },
];

export default content;
